$shm_agent_app_messages $mol_view
	sub <= rows /$mol_view

$shm_agent_app_attachments $mol_view
	empty true
	attr *
		^
		hidden <= empty
	sub <= rows /$mol_view

$shm_agent_app $mol_book2
	session_id? \
	server_url \http://127.0.0.1:4870
	sessions_page_visible true
	new_session_title? \
	search_query? \
	search_showed false
	attachments? /$shm_agent_attachment
	message_items /
	message_image_uri_resolve* \
	message_video_uri_resolve* \
	session_by_id*? null
	session_upsert? null
	thread_data? null
	chat_title \
	Send_icon $mol_icon_send
	Stop_icon $mol_icon_stop
	Fork_icon $mol_icon_source_fork
	Chat_settings_icon $mol_icon_dots_vertical
	Sessions_settings_icon $mol_icon_dots_vertical
	Tags_filter_icon $mol_icon_dots_vertical
	Session_tag_add_icon* $mol_icon_plus
	Message_reasoning_icon* $mol_icon_eye
	Message_copy_icon* $mol_icon_content_copy
	Message_remove_icon* $mol_icon_close
	Intermediate_toggle_icon $mol_icon_collapse_all
	Reasoning_close_icon $mol_icon_close
	File_close_icon $mol_icon_close
	Session* $mol_view
		attr *
			^
			current <= session_current* false
			archived <= session_archived*? false
			pinned <= session_pinned*? false
		sub /
			<= Session_link* $mol_link
				arg <= session_arg* *
				uri_off <= session_uri* \
				click? <=> session_select*? null
				sub /
					<= Session_info* $mol_view
						sub /
							<= Session_title_row* $mol_view
								sub <= session_title_rows* /
							<= Session_meta* $mol_view
								sub /
									<= Session_meta_text* $mol_view
										sub / <= session_meta* \
									<= Session_tags* $mol_view
										sub / <= session_tags_label* \
			<= Session_menu* $shm_agent_session_menu
				pinned? <=> session_pinned*?
				archived? <=> session_archived*?
				align \bottom_right
				hint \Действия с сессией
				remove? <=> session_delete*? null
				remove_confirm_title \Удалить сессию?
	Session_tag_new_bar* $mol_view
		sub /
			<= Session_tag_new* $mol_string
				hint \Новый тег
				value? <=> session_tag_new_value*? \
				submit? <=> session_tag_add*? null
			<= Session_tag_add* $mol_button_major
				title \Добавить тег
				sub / \
					<= Session_tag_add_icon*
				click? <=> session_tag_add*? null
	Session_tag_check* $mol_check_box
		title <= session_tag_title* \
		checked? <=> session_tag_checked*? false
	Session_markers* $mol_view
		sub <= session_marker_rows* /
	Session_title* $mol_view
		sub / <= session_title* \
	Session_busy* $mol_view
		attr *
			^
			title \Сессия сейчас в работе
			hidden <= session_busy_hidden* true
	Session_unread* $mol_view
		attr *
			^
			title \Есть непрочитанный ответ
		sub / \●
	Sessions_pick $mol_pick
		hint \Сессии агента
		align \bottom_left
		trigger_content /
			<= Sessions_current $mol_view
				sub / <= session_current_title \
		bubble_content /
			<= Sessions_panel
	Message* $mol_card
		theme <= message_theme* \
		attr *
			^
			role <= message_role_key* \
			queued <= message_queued* false
		sub /
			<= Message_head* $mol_view
				sub /
					<= Message_role* $mol_paragraph
						title <= message_role* \
					<= Message_reasoning_link* $mol_link
						arg <= message_reasoning_arg* *
						uri_off <= message_reasoning_uri_off* \
						sub /
							<= Message_reasoning_icon*
							<= message_reasoning_title* \Размышления
					<= Message_copy* $mol_button_copy
						hint \Копировать сообщение
						text <= message_text* \
						sub /
							<= Message_copy_icon*
					<= Message_time* $mol_paragraph
						title <= message_time* \
			<= Message_text_box* $mol_view
				sub <= message_content* /
	Message_text* $shm_agent_message_text
		text <= message_text* \
		embeds_allowed <= message_embeds_allowed* true
		file_open*? <=> message_file_open*? null
	Message_images* $mol_view
		sub <= message_image_rows* /
	Message_videos* $mol_view
		sub <= message_video_rows* /
	Message_error* $mol_view
		sub / <= message_error* \
	Message_state* $mol_view
		sub / <= message_state* \
	Message_actions* $mol_view
		sub /
			<= Message_force* $mol_button_minor
				enabled <= message_force_enabled* true
				sub / \Форсировать
				click? <=> message_force*? null
			<= Message_remove* $mol_button_minor
				hint \Удалить сообщение из очереди
				enabled <= message_remove_enabled* true
				sub /
					<= Message_remove_icon*
				click? <=> message_remove*? null
	Message_image* $shm_agent_media
		kind \image
		uri <= message_image_uri* \
	Message_video* $shm_agent_media
		kind \video
		uri <= message_video_uri* \
	Reply_loader* $mol_view
		attr *
			^
			title \Агент готовит ответ
		sub /
			<= Reply_elapsed* $mol_view
				sub / <= reply_elapsed* \
			<= Reply_dots* $shm_dotsloader
	pages <= app_pages /
		<= Sessions_page $mol_page
			head /
				<= Sessions_head $shm_agent_app_sessions_head
					title <= sessions_title \Агент
					add_title \Новая сессия
					filter? <=> search_query? \
					search_showed <= search_showed false
					add? <=> create? null
					close_content /
						<= Sessions_settings
					Close null
					Settings null
			body /
				<= Sessions_panel
		<= Chat_page $mol_page
			title_content <= chat_title_content /
				<= Chat_title $mol_string_button
					value? <=> chat_title_draft? \
					enabled <= chat_title_enabled true
					submit? <=> chat_title_commit? null
					event *
						^
						blur? <=> chat_title_commit? null
						keydown? <=> chat_title_keydown? null
			tools <= chat_tools /
			body <= chat_body /
				<= Messages_box* $mol_view
					sub /
						<= Messages* $shm_agent_app_messages
							event *
								scroll? <=> messages_scroll? null
							rows <= message_rows* /
			foot /
				<= Composer $mol_view
					attr *
						^
						drag <= attachment_drag_active false
					event *
						^
						dragenter? <=> attachment_drag_enter? null
						dragover? <=> attachment_drag_over? null
						dragleave? <=> attachment_drag_leave? null
						drop? <=> attachment_drop? null
					sub <= composer_content /
		<= Reasoning_page $mol_page
			title \Размышления
			tools /
				<= Reasoning_close $mol_button_minor
					hint \Закрыть размышления
					sub / <= Reasoning_close_icon
					click? <=> reasoning_close? null
			body /
				<= Reasoning_status $mol_paragraph
					title <= reasoning_status \
				<= Reasoning_parts $mol_list
					rows <= reasoning_rows /
		<= File_page $mol_page
			title <= file_title \
			tools /
				<= File_close $mol_button_minor
					hint \Закрыть файл
					sub / <= File_close_icon
					click? <=> file_close? null
			body /
				<= File_code $mol_text_code
					text <= file_text \
					sidebar_showed true
	Reasoning_part* $mol_card
		sub /
			<= Reasoning_part_title* $mol_paragraph
				title <= reasoning_part_title* \
			<= Reasoning_part_text* $shm_agent_message_text
				text <= reasoning_part_text* \
	Composer_attachments $shm_agent_app_attachments
		empty <= attachments_empty true
		rows <= attachment_rows /
	Attachment* $mol_view
		sub /
			<= Attachment_image* $mol_image
				uri <= attachment_uri* \
			<= Attachment_name* $mol_text
				text <= attachment_name* \
			<= Attachment_remove* $mol_button_minor
				title \Удалить изображение
				sub /
					<= Attachment_remove_icon* $mol_icon_close
				click? <=> attachment_remove*? null
	Composer_row $mol_view
		sub <= composer_row_content /
	Composer_actions $mol_view
		attr *
			^
			busy <= busy false
		sub <= composer_action_rows /
	Activity_error $mol_view
		sub / <= activity_error \
	Prompt $mol_textarea
		hint \Сообщение
		value? <=> prompt? \
		event *
			^
			paste? <=> attachment_paste? null
		submit? <=> steer? null
	Send $mol_button_minor
		hint <= send_hint \Отправить
		sub /
			<= Send_icon
		click? <=> send? null
	Stop $mol_button_minor
		hint \Остановить текущий ответ
		enabled <= stop_enabled true
		sub /
			<= Stop_icon
		click? <=> stop? null
	No_session $mol_view
		sub / \Выберите или создайте сессию
	Sessions_panel $mol_view
		attr *
			^
			standalone <= sessions_page_visible true
		sub /
			<= Sessions_scroll $mol_scroll
				sub /
					<= Sessions $mol_list
						rows <= session_rows /
	Tag_filter_check* $mol_check_box
		title <= tag_filter_title* \
		checked? <=> tag_filter_checked*? false
	Tags_filter_empty $mol_view
		sub / \Тегов пока нет
	Chat_provider $mol_view
		sub / <= chat_provider \
	Chat_settings $mol_pick
		hint \Настройки модели
		align \bottom_left
		trigger_content /
			<= Chat_settings_icon
		bubble_content /
			<= Chat_settings_content $mol_view
				sub <= chat_settings_rows /
	Sessions_settings $mol_pick
		hint \Настройки сессий
		align \bottom_right
		trigger_content /
			<= Sessions_settings_icon
		bubble_content /
			<= Sessions_settings_content $mol_view
				sub <= sessions_settings_rows /
	Sessions_limits_label $mol_labeler
		title \Лимиты
		Content <= Sessions_limits $mol_list
			rows <= session_limit_rows /
	Session_limit* $mol_labeler
		title <= session_limit_title* \
		Content <= Session_limit_value* $mol_view
			sub / <= session_limit_value* \
	Sessions_model_label $mol_labeler
		title \Модель по умолчанию
		Content <= Sessions_model $mol_select
			value? <=> agent_model_default_id? \
			options <= agent_model_options /
			dictionary <= agent_model_dict *
	Sessions_fast $mol_check_box
		title \Fast по умолчанию
		checked? <=> agent_fast_default_enabled? false
	Intermediate_toggle $mol_check_icon
		hint <= intermediate_toggle_hint \Скрыть промежуточные ответы
		checked? <=> intermediate_hidden? false
		Icon <= Intermediate_toggle_icon
	Model_label $mol_labeler
		title \Модель
		Content <= Model $mol_select
			value? <=> agent_model_id? \
			options <= agent_model_options /
			dictionary <= agent_model_dict *
	Session_fast $mol_check_box
		title \Fast
		checked? <=> agent_fast_enabled? false
	Fork $mol_button_minor
		title \Форкнуть чат
		enabled <= fork_enabled true
		sub /
			<= Fork_icon
		click? <=> fork? null
	Goal_settings $mol_pick
		hint <= goal_hint \Цель
		attr *
			^
			data-status <= goal_state \
		trigger_content /
			<= Goal_settings_icon $mol_icon_target
				attr *
					^
					data-status <= goal_state \
		bubble_content /
			<= Goal $mol_view
				sub /
					<= Goal_head $mol_view
						sub /
							<= Goal_title $mol_view
								sub / \Цель
							<= Goal_status $mol_view
								sub / <= goal_status \
					<= Goal_input $mol_textarea
						hint \Что должен сделать агент
						value? <=> goal_text? \
					<= Goal_actions $mol_view
						sub /
							<= Goal_set $mol_button_major
								sub / \Поставить цель
								click? <=> goal_set? null
							<= Goal_clear $mol_button_minor
								enabled <= goal_clear_enabled true
								sub / <= goal_clear_title \Остановить цель
								click? <=> goal_clear? null
